const calendar = {
  'calendar.title': 'Kalender',
  'calendar.today': 'Heute',
  'calendar.month': 'Monat',
  'calendar.week': 'Woche',
  'calendar.allTeams': 'Alle Teams',
  'calendar.ownOnly': 'Nur eigene',
  'calendar.error.load': 'Kalender konnte nicht geladen werden',
  'calendar.weekday.1': 'Mo',
  'calendar.weekday.2': 'Di',
  'calendar.weekday.3': 'Mi',
  'calendar.weekday.4': 'Do',
  'calendar.weekday.5': 'Fr',
  'calendar.weekday.6': 'Sa',
  'calendar.weekday.7': 'So',
  'calendar.type.ARBEITSZEIT_OFFICE': 'Arbeitszeit (Büro)',
  'calendar.type.ARBEITSZEIT_HOME_OFFICE': 'Arbeitszeit (Homeoffice)',
  'calendar.type.URLAUB_GENEHMIGT': 'Urlaub genehmigt',
  'calendar.type.URLAUB_OFFEN': 'Urlaubsantrag offen',
  'calendar.type.ABWESENHEIT': 'Abwesenheit',
  'calendar.type.ABWESENHEIT_FZT': 'FZT (Freizeittag)',
  'calendar.type.VERTRETUNG': 'Vertretung',
  'calendar.grouped.count': '{n} Einträge',
};

export default calendar;
